/*******
Common Function Used In Diamond Listing & Detail Page 
********/

/*** Pre Define Constant Values For Webservice Call ***/
const api = "https://py.xemplare.com/live/graphql/";
const rapnetDiamondListingApi = "diamondData";
const rapnetDiamondDetailApi = "diamondById";
const diamondSearchByReportApi = "devDiamondByStockorcert";
const rapnetDiamondAddToCart = "diamondAddToCart";
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** AddCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(diamondData) {
  var certificateFile = '';
  var diaLab = diamondData.lab;
  var diaCertNo = diamondData.certificateNumber;
  var diaCarat = diamondData.caratWeight;
  
  if(diamondData.certificateFile != ''){
    certificateFile = diamondData.certificateFile;
  }else{
    switch(diaLab)
      {
        case "GIA":
            certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+diaCertNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
            break;
        case "IGI":
            certificateFile = 'https://www.igi.org/verify-your-report/?r='+diaCertNo;
            break;
        case "HRD":
            certificateFile = 'https://my.hrdantwerp.com/?record_number='+diaCertNo+'&weight='+diaCarat;
            break;
        case "AGS":
            certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+diaCertNo+'&Weight='+diaCarat+'&D=1';
            break;
        default:
            certificateFile = "";
      }
  }    
  return certificateFile;
}
/*** End ***/

/*** Diamond Broken Image Fixes start ***/ 
function imgError(image,defaultImage) {
  image.onerror = "";
  image.src = defaultImage;
  return true;
}
/*** End ***/  

/*** Get Diamond Price Start ***/
function getDiamondPrice(currencyRate,finalPrice) {  
  var final_dia_price = finalPrice * currencyRate; 
  var dia_formatted_price = Math.ceil(final_dia_price);      
  dia_formatted_price = Shopify.formatMoney(dia_formatted_price * 100, theme.moneyFormat);  
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Price Start ***/
function getDiamondPriceWithCurrencySymbol(currencyCode,currencyRate,finalPrice) {  
  var format = moneyFormats[currencyCode].money_format; 
  var final_dia_price = finalPrice * currencyRate;   
  var dia_formatted_price = Math.ceil(final_dia_price);  
  var final_formatted_price = formatMoney(dia_formatted_price*100, format);
  return final_formatted_price;
}
/*** End ***/

/*** Get Price Start With Currency Symbol ***/
function getPriceWithCurrencySymbol(currencyCode,finalPrice) {  
  var format = moneyFormats[currencyCode].money_format;   
  var formatted_price = Math.ceil(finalPrice*100);       
  var final_formatted_price = formatMoney(formatted_price, format);
  return final_formatted_price;
}
/*** End ***/

/*** Get Currency Symbol Start ***/
function getCurrencySymbol(CurrenyCode) {
	var currency_symbol2;
	switch (CurrenyCode) {
		case "AUD":
			currency_symbol2 = "AU$";
			break;
		case "NZD":
			currency_symbol2 = "NZ$";
			break;
    case "EUR":
			currency_symbol2 = "€";
			break;
		case "GBP":
			currency_symbol2 = "£";
			break;		
    case "USD":
			currency_symbol2 = "US$";
			break;		
		default:
			currency_symbol2 = "AU$"
	}
	return currency_symbol2
}
/*** End ***/

/*** Get Diamond Price Start ***/
function getDiamondPriceFilter(currencyRate,finalPrice) {  
  currencyRate = parseFloat(currencyRate).toFixed(3);
  var final_dia_price = finalPrice / currencyRate; 
  var dia_formatted_price = Math.floor(final_dia_price);  
  dia_formatted_price = dia_formatted_price -1;
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Price Start ***/
function getDiamondPriceFiltertotal(currencyRate,finalPrice) {  
  //currencyRate = parseFloat(currencyRate).toFixed(3);
  var final_dia_price = finalPrice * currencyRate; 
  var dia_formatted_price = Math.floor(final_dia_price);      
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Price Start ***/
function getDiamondPriceFiltertotalreverse(currencyRate,finalPrice) {  
  currencyRate = parseFloat(currencyRate).toFixed(3);
  var final_dia_price = finalPrice / currencyRate; 
  var dia_formatted_price = Math.floor(final_dia_price);  
  dia_formatted_price = dia_formatted_price -1;
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Price Start ***/
function getDiamondPriceFilterReverseTotal(currencyRate,finalPrice) {  
  // currencyRate = parseFloat(currencyRate).toFixed(3);
  var final_dia_price = finalPrice / currencyRate; 
  var dia_formatted_price = Math.floor(final_dia_price);  
  dia_formatted_price = dia_formatted_price;
  return dia_formatted_price;
}
/*** End ***/

/*** Get Diamond Type Start ***/
function getDiamondType(diamondType) {
  var type = diamondType;
  if(type == 'white'){
    dia_type = 'Natural';
  }else{
    dia_type = 'fancy';
  }
  return dia_type;
}
/*** End ***/

/*** Get Diamond Name Start ***/
// function getDiamondName(diamondData,diamondType) {
//   let dia_carat = diamondData.caratWeight;

//   // If number has exactly 1 decimal place, convert to 2 decimal places
//   if (Number(dia_carat) % 1 !== 0 && dia_carat.toString().split('.')[1].length === 1) {
//     dia_carat = Number(dia_carat).toFixed(2);
//   }
//   var diamond_name = dia_carat + "-Carat " + diamondData.shape + " Shape "+ diamondType +" Diamond ";
//   return diamond_name;
// }
function getDiamondName(diamondData, diamondType) {
  let dia_carat = Number(diamondData.caratWeight).toFixed(2);

  var diamond_name =
    dia_carat +
    "-Carat " +
    diamondData.shape +
    " Shape " +
    diamondType +
    " Diamond";

  return diamond_name;
}

/*** End ***/

/*** Get Diamond measurement Start ***/
function getDiamondMeasurement(diamondData) {
  function fixDecimal(num) {
    if (num != null && !isNaN(num)) {
      return Number(num).toFixed(2);
    }
    return num;
  }
  if(diamondData.measurement != '' || diamondData.measurement != 'undefined' ){
    var dia_length = fixDecimal(diamondData.length);
    var dia_width = fixDecimal(diamondData.width);
    var dia_depth = fixDecimal(diamondData.depth);
    var measurements = dia_length + " * " + dia_width + " * " + dia_depth;
  }else{
    var measurements = diamondData.measurement;
  }  
  return measurements;
}
/*** End ***/

/*** Get Diamond Girdle Start ***/
function getDiamondGirdle(diamondData) {
  if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }else if(diamondData.girdleMax == '' && diamondData.girdleMax == 0){
    var girdle = diamondData.girdleMin;
  }else if(diamondData.girdleMin == '' && diamondData.girdleMax == 0){
    var girdle = diamondData.girdleMax;
  }else{
    var girdle = 'NA';
  }  
  return girdle;
}
/*** End ***/

/*** Diamond Smart Option Layout Start ***/
function getSmartOptionsLayoutBadge(diamondData){
    var smartOptionsLayout = '';
    if(diamondData.eyeClean != "False" || diamondData.bgmHanda != "False" || diamondData.heartAndArrow != "False"){
      smartOptionsLayout += '<div class="tps-diamondlist-detail-view-smart-options">';
      if(diamondData.eyeClean != "False" && diamondData.eyeClean != ""){
        smartOptionsLayout += '<div class="tps-diamondlist-detail-view-smartoptions tps-smart-option-eyeclean">'+translations.titleEyeClean+'</div>';
      }  
      if(diamondData.luster == "" && diamondData.colourTinge == ""){
        smartOptionsLayout += '<div class="tps-diamondlist-detail-view-smartoptions tps-smart-option-nobgm">'+translations.titleNoBgm+'</div>';
      } 
      
      if(diamondData.heartAndArrow != "False" && diamondData.heartAndArrow != ""){
        smartOptionsLayout += '<div class="tps-diamondlist-detail-view-smartoptions tps-smart-option-heartandarraow">'+translations.titleHeartAndArrow+'</div>';
      } 
      smartOptionsLayout += '</div>';
    }
    return smartOptionsLayout;
}
/*** Diamond Smart Option Layout End ***/

/*** Get Diamond Detail Information Layout ***/
function getDiamondInformationLayout(diamondData) {
 
  var diamond_certificate_url = getCertificateUrl(diamondData);
  var diamond_measurements = getDiamondMeasurement(diamondData);
  var diamond_ratio_value = diamondData.length / diamondData.width;
  var diamond_ratio = parseFloat(diamond_ratio_value.toFixed(2));
  // var diamond_ratio = diamondData.ratio;
   if(diamond_ratio == '0.0'){
     var dia_ratio = 0.0;
   }else{
     var dia_ratio = diamond_ratio;
   }
  //console.log('dia_ratio',dia_ratio);

  var diamond_girdle = diamondData.girdle;
  if(diamond_girdle == null){
    if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
      diamond_girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
    }else{
      diamond_girdle = "-";
    }   
  }

  // var dia_carat = diamondData.caratWeight;
  // if (Number(dia_carat) % 1 !== 0 && dia_carat.toString().split('.')[1].length === 1) {
  //   dia_carat = Number(dia_carat).toFixed(2);
  // }
  var dia_carat = diamondData.caratWeight;
  dia_carat = Number(dia_carat).toFixed(2);

  var dia_table = diamondData.tablePerc;
  dia_table = Number(dia_table).toFixed(2);

  var dia_depth = diamondData.deptPerc;
  dia_depth = Number(dia_depth).toFixed(2);
  
  //Dynamic Diamond Information Array 
  var diamondInformation = {
    "diamondStockId" : translations.titleStockID+' - '+diamondData.stockNumber,
    "diamondShape"   : translations.titleShape+' - '+diamondData.shape,
    "diamondCarat"   : translations.titleCaratWeight+' - '+dia_carat,
    "diamondCut"     : translations.titleCut+' - '+diamondData.cut,
    "diamondColor"   : translations.titleColor+' - '+diamondData.color,
    "diamondFancyColor" : translations.titlefancyColor+' - '+diamondData.fancyColor,
    "diamondClarity" : translations.titleClarity+' - '+diamondData.clarity,
    "diamondReport"  : translations.titleGradingReport+' - '+diamondData.lab+' - '+diamond_certificate_url,
    "diamondFluorescence" : translations.titleFluorescence+' - '+diamondData.flourIntensity,
    "diamondTable"   : translations.titleTable+' - '+dia_table,
    "diamondDepth"   : translations.titleDepth+' - '+dia_depth,
    "diamondMeasurement" : translations.titleMeasurement+' - '+diamond_measurements,   
    "diamondSymmetry": translations.titleSymmetry+' - '+diamondData.symmetry,
    "diamondPolish"  : translations.titlePolish+' - '+diamondData.polish,
    "diamondgirdle"  : translations.titleGirdle+' - '+diamond_girdle,
    "diamondCrownAngle"   : translations.titleCrownAngle+' - '+diamondData.crownAngle,
  };
  //end
  if (diamondData.shape.toLowerCase() !== "round") {
  diamondInformation.diamondRatio = translations.titleRatio + ' - ' + dia_ratio;
}

  //Diamond Information HTML Layout
  var detailInfo = '';
  if(diamondInformation != ''){
     var j = 1;
     $.each(diamondInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         var infoValue = diamondInfoArray[1];
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info"><a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a></span></div> ';
           }else{
             if(infoValue != 'null'){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
/*** End ***/

/*** Config function forpre define module url start ***/
var tps_config = {
  "urls": {        
        "loose_diamond": "/pages/natural-white-diamonds",
        "lab_diamond": "/pages/lab-grown-white-diamonds",
        "loose_color_diamond": "/pages/natural-colour-diamonds", 
        "lab_color_diamond": "/pages/lab-grown-color-diamonds",
        "loose_diamond_detail": "/pages/loose-diamond-details",
  }
}
/*** End ***/


/*** Show Product Detail & Final Ring Page Loader Start ***/
function showProductLoader(galleryStyle){
  if(galleryStyle == 'grid-view'){            
    if(jQuery(window).width() <= 767){
      jQuery(".tps-loader-horizontal-thumb-slider").show();
    }else{
      jQuery(".tps-loader-"+galleryStyle).show();
    }
  }else{
    jQuery(".tps-loader-"+galleryStyle).show();
  }
}
/*** Show Product Detail & Final Ring Page Loader End ***/

/*** Remove HTML Elements In Mobile ***/
function removeHtmlElementsInMobile() {  
  jQuery('.tps-mobile-hide').remove();	
}
/*** End ***/

/*** Remove HTML Elements In Desktop ***/
function removeHtmlElementsInDesktop() {
  jQuery('.tps-desktop-hide').remove();	
}
/*** End ***/

jQuery(document).ready(function() {
  // Check if the page is the cart page
  if (window.location.pathname == '/cart') {
    jQuery(".cart-section").addClass("quantity-disabled");
  }
});

/*******
End
********/